import clsx from 'clsx';
import React, { ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import CustomSelect from "../UI/customSelect/customSelect";
import { useMutation, useQuery } from 'react-query';
import { Delete, Get, Post } from 'src/apis/api';
import Loading from 'src/components/Loading';
import { ListResponseType, Visa } from 'src/types';
import { Close } from 'src/icons/icons';
import { toast } from 'react-toastify';
import CustomButton from '../UI/customButton/customButton';

export const DeleteVisa = ({ visaId, onSuccessMutate, children }: { visaId: string, onSuccessMutate: Function, children?: ReactNode }) => {

    const { t } = useTranslation();

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

    const { isLoading, mutate } = useMutation<{}, { data: { message: string, msg: string } }>({
        mutationFn: () => Delete(`agent/visas/destroy/${visaId}`),
        mutationKey: ['DeleteVisa', visaId],
        onSuccess: (res: any) => {
            toast.success(res.msg);
            onSuccessMutate()
            setIsModalOpen(false)
        },
        onError: (error) => {
            toast.error(error?.data?.message || error?.data?.msg);
        },
    })


    return (
        <>

            {!!children
                ? <div className='flex' title={t('delete')} onClick={() => setIsModalOpen(true)}>{children}</div>
                :
                <button
                    className='bg-red text-rose-100 p-2 rounded-lg  min-w-28 text-sm font-bold gap-2 flex flex-row items-center justify-center'
                    title={t('delete')}
                    onClick={() => setIsModalOpen(true)}
                >
                    <Close color='red' />
                    {t('delete')}
                </button>

                // <button className='bg-primary-200  text-primary-400  p-2 rounded-lg text-sm font-bold lg:min-w-32' title={t('delete')} onClick={() => setIsModalOpen(true)}>
                //     {t('delete')}
                //     </button>

            }



            {isModalOpen && createPortal(<div className={clsx('fixed top-0 left-0 h-full w-full backdrop-brightness-50 z-40 flex flex-row justify-center items-center', !isModalOpen ? 'opacity-0' : ' opacity-100')}>
                <div className={clsx('flex flex-col gap-4 transition-all duration-300 bg-white max-w-[80vw] lg:max-w-[450px] min-w-64 rounded-2xl border p-4 pt-5 relative', !isModalOpen ? 'translate-y-full' : 'translate-y-0')}>

                    <div className='absolute left-3 top-3 cursor-pointer' onClick={() => setIsModalOpen(false)}> <Close color='gray' /></div>

                    <span className='text-primary-400 text-lg text-center p-4 pb-0'>{t('AreYouSureToDeleteVisa')}</span>



                    <div className={"grid grid-cols-2 pt-2 gap-5"}>
                        <CustomButton loading={isLoading} onClick={() => mutate()} styles={"!text-red bg-white !text-sm border border-white"} title={t("yesDelete")} />
                        <CustomButton onClick={() => setIsModalOpen(false)} styles={"!text-sm !p-0 "} title={t("doNotDelete")} />

                    </div>
                </div>

            </div>
                , document.body)}
        </>
    )
}
